import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import GalleryDetails from "./galleryDetails";
import GalleryBanner from "./galleryBanner";

const Gallery = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <GalleryBanner />
      <GalleryDetails />
      <FooterThree />
    </>
  );
};

export default Gallery;
